import { Deserializable } from '../deserializable';

export class QueueNotification implements Deserializable{

    public id: number;
    public notificationType: string;
    public status: string;
    public statusMessage: string;
    
    public createdDate: Date;
    public updatedDate: Date;


    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
